import React from 'react';
import EntityHistoryCard from './EntityHistoryCard';

export default function EntityHistoryList({
  items = [],
  isLoading = false,
  emptyMessage = 'No history available',
  fieldLabels = {},
  actionLabels = {},
  renderCard,
  loadingComponent,
}) {
  if (isLoading) {
    if (loadingComponent) {
      return loadingComponent;
    }
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
      </div>
    );
  }

  if (!items || items.length === 0) {
    return (
      <div className="flex justify-center items-center py-12">
        <p className="text-gray-500 text-lg italic">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {items.map((history, index) => {
        if (renderCard) {
          return renderCard(history, index);
        }

        return (
          <EntityHistoryCard
            key={history.id || index}
            history={history}
            fieldLabels={fieldLabels}
            actionLabelsOverride={actionLabels}
          />
        );
      })}
    </div>
  );
}
